<!-- eslint-disable vue/no-v-text-v-html-on-component -->
<template>
	<nk-box
		v-if="
			context &&
			((context.id && context.id === options.showForId) || !options.showForId)
		"
		variant="sidebar"
	>
		<nk-title v-if="context.titel" size="lg" v-html="context.titel" />

		<div v-if="context.text" class="nk-cms-content" v-html="context.text" />

		<nk-button
			v-if="context.link"
			class="mt-3"
			variant="link"
			:link="context.link"
			append-icon="arrow-right"
			size="collapse"
		>
			{{ context.linktext || 'Mehr erfahren' }}
		</nk-button>
	</nk-box>
</template>

<script>
import TemplatesDefault from '../../mixins/templates-default';

/**
 * @prop {object} context
 * @prop {string} context.title
 * @prop {string} context.link
 * @prop {string} context.linktext
 * @prop {string} context.text
 * @prop {number} context.id
 * @prop {number} options.showForId
 */
export default {
	name: 'NkSidebarText',

	mixins: [TemplatesDefault],
};
</script>
